<template>
  <v-dialog v-model="openDialog"
            max-width="400" lazy>
    <v-card>
      <v-card-title class="title">Pick Up</v-card-title>
      <v-layout column class="px-3">
        <v-layout column class="pr-5">
          <v-float-field label="Animal Count"
                         :error-messages="errorMessages"
                         v-model="animalCount"/>
          <v-float-field :label="pickupDialogWeightLabel" v-model="animalWeight"/>
        </v-layout>
        <v-layout>
          <date-picker
            input-id="deliveryTimePicker"
            placeholder="Estimated Delivery Date"
            v-model="estimatedDeliveryTime">
          </date-picker>
        </v-layout>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn color="accent"
               :disabled="!validAnimalCount"
               @click="setPickup">Picked Up</v-btn>
        <v-btn flat color="accent" @click="openDialog = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</template>

<script>
import API from '@/api/index';
import VFloatField from '@/components/VFloatField';
import DatePicker from '@/components/DatePicker';

import * as types from '@/store/mutationTypes';
import * as Timestamps from '@/types/timestamp';
import unitsOfMeasurePlugin from '../../mixins/unitsOfMeasurePlugin';

export default {
  name: 'PickupLoadDialog',
  props: {
    value: {
      type: Boolean,
    },
    loadId: {
      type: String,
    },
  },
  data() {
    return {
      animalCount: null,
      animalWeight: null,
      estimatedDeliveryTime: '',
      openDialog: this.value,
    };
  },
  mixins: [
    unitsOfMeasurePlugin,
  ],
  components: {
    VFloatField,
    DatePicker,
  },
  watch: {
    value() {
      this.openDialog = this.value;
      if (!this.value) {
        this.resetForm();
      }
    },
    openDialog() {
      this.$emit('input', this.openDialog);
    },
  },
  computed: {
    errorMessages() {
      return this.validAnimalCount || this.animalCount === null ? null : ['Animal Count must be 1 or more'];
    },
    validAnimalCount() {
      return this.animalCount && this.animalCount > 0;
    },
    pickupDialogWeightLabel() {
      return `Animal Weight in ${ this.siteWeightMeasureLabel }.`;
    }
  },
  methods: {
    resetForm() {
      this.animalCount = null;
      this.animalWeight = null;
      this.estimatedDeliveryTime = '';
    },
    async setPickup() {
      const myEta = Timestamps.localizedPickerTimestamp(this.estimatedDeliveryTime);
      this.$store.commit(`applications/${types.START_LOADING}`);
      try {
        const params = {
          loadId: this.loadId,
          pickupInfo: {
            animalCount: this.animalCount,
            // pounds is known to be deprecated. once US/AU backends converge we'll remove
            animalWeightPounds: this.animalWeight,
            animalWeight: this.animalWeight,
            estimatedDelivery: myEta,
            when: new Date().toISOString(),
          },
        };
        await API.load.setPickup(params);
        this.$store.dispatch('applications/setSuccessNotification', {
          message: 'Picked up successfully!',
        });
        this.$emit('refresh');
        this.openDialog = false;
      } catch ({ message }) {
        this.$store.dispatch('applications/setErrorNotification', {
          message,
        });
      } finally {
        this.$store.commit(`applications/${types.END_LOADING}`);
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/modals/PickupLoadDialog.vue